<template>
    <v-dialog scrollable max-width="600px" v-model="showDialog">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" color="info" small :loading="loadingReport"
                :disabled="!$store.getters.user.roles.includes('CONSULTAPAGOS')">Descargar PENDIENTES</v-btn>
        </template>

        <v-card>
            <v-card-title>
                <h4>Ingrese algun parametro</h4>
            </v-card-title>
            <v-card-text>
                <v-form ref="form">

                    <periodo-distribucion-autocomplete @periodoDistribucion="setPeriodoDistribucion"
                        :periodoDistribucion="periodoDistribucion" clearable />
                    <GeneracionAutocomplete ref="asig" returnObject :required=false :filtroEstado="[
                        'Pendiente',
                        'Cerrado',
                        'Liquidado',
                        'Liquidando',
                    ]" @generacionId="setGeneracionId" />
                </v-form>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="info" @click="showDialog = false" small>Volver</v-btn>
                <v-btn color="info" small @click="descargarEstadosPagosContabilidadPendientes()"
                    :loading="loadingReport">Descargar PENDIENTES</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>
<script>
import axios from "axios";
import { saveAs } from "file-saver";
import GeneracionAutocomplete from "@/components/shared/GeneracionAutocomplete.vue";
import PeriodoDistribucionAutocomplete from "@/components/shared/PeriodoDistribucionAutocomplete.vue";



export default {
    data() {
        return {
            generaciones: [],
            generacion: null,
            errorMessage: "",
            periodoDistribucion: null,
            loading: false,
            loadingReport: false,
            showDialog: false,
            rules: {
                required: (value) => !!value || "Requerido.",
            },
        };
    },
    components: {
        GeneracionAutocomplete,
        PeriodoDistribucionAutocomplete,
    },
    mounted() {
    },
    methods: {
        setGeneracionId(generacion) {
            this.generacion = generacion;
        },
        descargarEstadosPagosContabilidadPendientes() {
            this.loadingReport = true;

            const params = {
                generacionId: this.generacion ? this.generacion.id : null,
                idPeriodoDistribucion: this.periodoDistribucion ? this.periodoDistribucion.id : null,
            };

            const url = "/report/estadosPagosContabilidadPendientes";

            axios
                .get(url, { params })
                .then((response) => {
                    var blob = this.b64toBlob(
                        response.data.fileContent,
                        "application/excel",
                        null
                    );
                    saveAs(blob, response.data.fileName);
                    this.loadingReport = false;
                    this.showDialog = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.errorMessage = "Error en la consulta";
                    this.loadingReport = false;
                });
        },

        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || "";
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (
                var offset = 0;
                offset < byteCharacters.length;
                offset += sliceSize
            ) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },
        setPeriodoDistribucion(e) {
            this.periodoDistribucion = e;
        },

    },
};
</script>